import React from 'react'
import styles from './MainWindow.styles'
import { observer } from 'mobx-react-lite'
import { makeStyles } from '@material-ui/core/styles'
import { useStore } from 'store/useStore'
import { Route, Switch } from 'react-router-dom'
import PrivateRoute from '@voicekey/components-base/privateRoute/PrivateRoute'
import LINKS from 'App.const'
import SuspenseFallback from '../../components/routes/SuspenseFallback'

const useStyles = makeStyles(styles, { name: 'MainWindow' })

function MainWindow () {
  const classes = useStyles()
  const { sessionStore, configuratorStoreSettings } = useStore()

  return (
    <div className={classes.main}>
      <SuspenseFallback>
        <Switch>
          <Route
            exact
            path={LINKS.MAIN.NO_PAGE.path}
            component={LINKS.MAIN.NO_PAGE.component}
          />
          <Route
            exact
            path={LINKS.MAIN.DOCUMENTATION.path}
            component={LINKS.MAIN.DOCUMENTATION.component}
          />
          <Route
            exact
            path={LINKS.MAIN.AUTH_CONFIGURATOR.path}
            component={LINKS.MAIN.AUTH_CONFIGURATOR.component}
          />
          <PrivateRoute
            path={LINKS.MAIN.CONFIGURATOR.path}
            isOpen={!!configuratorStoreSettings.token}
            component={LINKS.MAIN.CONFIGURATOR.component}
            redirectPath={LINKS.MAIN.AUTH_CONFIGURATOR.path}
          />
          <Route
            path={LINKS.MAIN.START_PAGE.path}
            component={LINKS.MAIN.START_PAGE.component}
          />
          <PrivateRoute
            exact
            path={LINKS.MAIN.SETTINGS.path}
            isOpen={!!sessionStore.sessionId}
            component={LINKS.MAIN.SETTINGS.component}
            redirectPath={LINKS.MAIN.AUTHORIZATION.path}
          />
          <PrivateRoute
            exact
            path={LINKS.MAIN.PROJECTS_PAGE.path}
            isOpen={!!sessionStore.sessionId}
            component={LINKS.MAIN.PROJECTS_PAGE.component}
            redirectPath={LINKS.MAIN.START_PAGE.path}
          />
          <PrivateRoute
            path={LINKS.MAIN.PROJECTS_PAGE.path}
            isOpen={!!sessionStore.sessionId}
            component={LINKS.MAIN.PROJECTS_PAGE.component}
            redirectPath={LINKS.MAIN.AUTHORIZATION.path}
          />
        </Switch>
      </SuspenseFallback>
    </div>
  )
}

export default observer(MainWindow)
